module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/first.js
// module id = 764
// module chunks = 0